import { Box } from "@mui/material";

export default function MobileView(props: { children: React.ReactNode }) {
	return (
		<Box display={{ xs: "block", md: "none" }} className="fullwidth-container">
			{props.children}
		</Box>
	);
}
